import * as z from "zod";
import UserRoleTypeEnum from "@/constants/enums/UserRoleTypeEnum";
import { UserRoleType } from "@/types";

// Derived from the enum so new roles are invitable without touching this file.
const ROLE_VALUES = Object.values(UserRoleTypeEnum) as [UserRoleType, ...UserRoleType[]];

const validationSchema = z.object({
  firstname: z.string().min(1, { message: "validation:firstNameRequired" }),
  lastname: z.string().min(1, { message: "validation:lastNameRequired" }),
  email: z.string().min(1, { message: "validation:emailRequired" }),
  // phone: z.string().optional(),
  role: z.enum(ROLE_VALUES, {
    message: "validation:roleTypeRequired",
  }),
  // languageIsoName: z.string().min(1, { message: "validation:languageRequired" }),
  //companyId: z.number(),
});

export const InviteUserValidationSchema = validationSchema;
export type InviteUserFormInput = z.infer<typeof InviteUserValidationSchema>;
